// extracted by mini-css-extract-plugin
module.exports = {"container":"ScreenSizeButton_container__x2XrF","close":"ScreenSizeButton_close__2cKUM"};